/*
 * Copyright (C) 2018 - present by Potentially
 *
 * Please see distribution for license.
 */

import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { environment } from '@app/environments/environment';
import { TranslocoService } from '@ngneat/transloco';
import { catchError, switchMap } from 'rxjs/operators';
import { RestClientService } from '../../../shared/services/rest-client.service';
import { ObservableResult } from '../../../shared/store';
import {
  OutlookAuthUrlResponse,
  OutlookBulkSyncResponse,
  OutlookDataService,
  OutlookDisconnectResponse,
  OutlookStatusResponse,
  OutlookSyncEventResponse,
} from './outlook-data.service';

@Injectable()
export class ApiOutlookDataService implements OutlookDataService {
  private baseUrl = Location.joinWithSlash(environment.apiRootUrl || '', 'outlook');

  constructor(
    private restClient: RestClientService,
    private translocoService: TranslocoService,
  ) {}

  getAuthUrl(): ObservableResult<OutlookAuthUrlResponse> {
    return this.restClient.get<OutlookAuthUrlResponse>(`${this.baseUrl}/auth-url`).pipe(
      switchMap(({ body }) => ObservableResult.ofSuccess(body)),
      catchError(() => ObservableResult.ofError(this.translocoService.translate('translations.errors.errorOutlookGetAuthUrl'))),
    );
  }

  getStatus(): ObservableResult<OutlookStatusResponse> {
    return this.restClient.get<OutlookStatusResponse>(`${this.baseUrl}/status`).pipe(
      switchMap(({ body }) => ObservableResult.ofSuccess(body)),
      catchError(() => ObservableResult.ofError(this.translocoService.translate('translations.errors.errorOutlookGetStatus'))),
    );
  }

  disconnect(): ObservableResult<OutlookDisconnectResponse> {
    return this.restClient.delete<OutlookDisconnectResponse>(`${this.baseUrl}/disconnect`).pipe(
      switchMap(({ body }) => ObservableResult.ofSuccess(body)),
      catchError(() => ObservableResult.ofError(this.translocoService.translate('translations.errors.errorOutlookDisconnect'))),
    );
  }

  syncAll(): ObservableResult<OutlookBulkSyncResponse> {
    return this.restClient.post<OutlookBulkSyncResponse>(`${this.baseUrl}/sync-all`, {}).pipe(
      switchMap(({ body }) => ObservableResult.ofSuccess(body)),
      catchError(() => ObservableResult.ofError(this.translocoService.translate('translations.errors.errorOutlookSyncEvents'))),
    );
  }

  syncEvent(eventId: string): ObservableResult<OutlookSyncEventResponse> {
    return this.restClient.post<OutlookSyncEventResponse>(`${this.baseUrl}/sync-event/${eventId}`, {}).pipe(
      switchMap(({ body }) => ObservableResult.ofSuccess(body)),
      catchError(() => ObservableResult.ofError(this.translocoService.translate('translations.errors.errorOutlookSyncEvent'))),
    );
  }
}
